export const PRODUCT_NAME = 'Mevo Receita Digital';
export const PARTNER_ID = '331';
